import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { IEmployeeResponse, ISessionData, IUser } from '@models';
import { Observable } from 'rxjs';
import { LocalDbService } from '../external/local-db.service';
import { TokenKeysEnum } from '@enums';

@Injectable({
  providedIn: 'root'
})
export class DataCentralService {
  constructor(private localDB: LocalDbService, private navCtrl: NavController) {}

  public get accessToken(): string {
    return this.localDB.accessToken;
  }

  public get refreshToken(): string {
    return this.localDB.refreshToken;
  }

  public get user(): IUser {
    return this.localDB.user;
  }

  public get user$(): Observable<IUser> {
    return this.localDB.userAsSubject.asObservable();
  }

  public get employee(): IEmployeeResponse {
    return this.localDB.employee;
  }

  public get employee$(): Observable<IEmployeeResponse> {
    return this.localDB.employeeAsSubject.asObservable();
  }

  public get sessionExpires(): number {
    return this.localDB.sessionExpires;
  }

  public async initLocalDB(): Promise<void> {
    await this.localDB.init();
  }

  public async saveSession(session: ISessionData): Promise<void> {
    const FIFTEEN_MINUTES = 900_000;
    const timestamp = Date.now() + FIFTEEN_MINUTES;
    await this.localDB.updateBasicInfo({
      user: session.User,
      accessToken: session.AccessToken,
      refreshToken: session.RefreshToken,
      timestamp
    });
  }

  public async clearSession(): Promise<void> {
    await this.localDB.clearSession();
  }

  public async saveEmployee(employee: IEmployeeResponse): Promise<void> {
    await this.localDB.updateState(TokenKeysEnum.EMPLOYEE, employee);
  }
}
